/* eslint-disable jsx-a11y/media-has-caption */
import React, { ReactElement } from 'react';
import { Box } from '@chakra-ui/react';
import { useModalService } from 'hooks/useModalService';
import { ModalVariant } from 'types/Modal';
import PlaceholderImage from '../../../assets/common/placeholder.png';
import { CustomPlayButton } from './CustomPlayButton';
import { LazyImage } from '../LazyImage';

type Props = {
  videoUrl: string;
  videoDescription?: string;
  isEmbedded?: boolean;
  thumbnailUrl?: string;
  onVideoEnd?: () => void;
  onVideoAbort?: () => void;
};

export const VideoBox = ({
  videoUrl,
  videoDescription = '',
  isEmbedded = false,
  thumbnailUrl = PlaceholderImage,
  onVideoEnd,
  onVideoAbort,
}: Props): ReactElement => {
  const modalService = useModalService();

  const handleOpenModal = (): void => {
    modalService.show(ModalVariant.VIDEO, {
      videoUrl,
      videoDescription,
      thumbnailUrl,
      isEmbedded,
      onVideoEnd,
      onVideoAbort,
    });
  };

  const getThumbnailBox = (): ReactElement | null => {
    if (!videoUrl) return null;

    if (isEmbedded)
      return (
        <LazyImage
          src={thumbnailUrl || PlaceholderImage}
          alt={videoDescription}
          objectFit="cover"
          height="100%"
          width="100%"
          fallbackSrc={PlaceholderImage}
          loading="lazy"
        />
      );

    return (
      <Box as="video" width="100%" height="100%" objectFit="cover">
        <source src={videoUrl} type="video/mp4" />
      </Box>
    );
  };

  return (
    <Box height="100%" position="relative" cursor="pointer" onClick={handleOpenModal}>
      <Box
        height="100%"
        width="100%"
        position="absolute"
        top="0"
        left="0"
        display="grid"
        placeItems="center"
      >
        <CustomPlayButton />
        <Box
          height="100%"
          width="100%"
          position="absolute"
          top="0"
          left="0"
          background="#505050"
          opacity="30"
        />
      </Box>
      {getThumbnailBox()}
    </Box>
  );
};
